"use client";

import { X } from "@app-foundation/icons/lucide";

import { useState } from "react";
import { createPortal } from "react-dom";
import { LicenseScopeDocument } from "./LicenseScopeDocument";
import scopeDocument from "./scope-document.json";

export function LicenseScopeDescription() {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" className="cursor-pointer font-semibold text-[var(--color-accent)] underline underline-offset-4" onClick={() => setOpen(true)}>《{scopeDocument.title}》</button>
    {open && createPortal(<dialog
      ref={element => { if (element && !element.open) element.showModal(); }}
      aria-label={scopeDocument.title}
      onClose={() => setOpen(false)}
      className="fixed inset-0 m-auto max-h-[86vh] w-[760px] max-w-[94vw] overflow-auto rounded-2xl border border-[var(--color-line)] bg-[var(--color-surface)] p-6 text-[var(--color-paper)] shadow-xl backdrop:bg-black/60 sm:p-8"
    >
      <LicenseScopeDocument />
      <div className="mt-6 flex justify-end"><button type="button" className="rounded-lg border border-[var(--color-line)] px-5 py-2 text-sm" onClick={() => setOpen(false)}><span className="sr-only">关闭</span><X size={20} aria-hidden="true" className="inline-block" /></button></div>
    </dialog>, document.body)}
  </>;
}
